@import '../../../node_modules/@shoelace-style/shoelace/dist/themes/light.css';

:host {
  /* Definizione delle variabili per il nostro componente */
  --jump-switch-width: 36px;
  --jump-switch-height: 20px;
  --jump-switch-thumb-size: 14px;
  --jump-switch-thumb-color: var(--neutral-white, #ffffff);
  --jump-switch-active-color: var(--secondary-standard, #5e79ba);
  --jump-switch-inactive-color: var(--neutral-grey-disabled, #cbcbcb);
  --jump-switch-disabled-opacity: 0.5;
  --jump-switch-font-family: var(--ff-primary, 'Inter', sans-serif);
  --jump-switch-font-size: 16px;
  --jump-switch-font-weight: normal;
  --jump-switch-label-color: var(--neutral-black, #000000);

  display: flex;
  align-items: center;
  width: 100%;

  /* Stile diretto per Shoelace switch */
  sl-switch::part(base) {
    width: 100%;
    font-family: var(--jump-switch-font-family);
    font-size: var(--jump-switch-font-size);
    font-weight: var(--jump-switch-font-weight);
    color: var(--jump-switch-label-color);
  }

  sl-switch::part(control) {
    width: var(--jump-switch-width) !important;
    height: var(--jump-switch-height) !important;
    background-color: var(--jump-switch-inactive-color) !important;
    border-color: var(--jump-switch-inactive-color) !important;
  }

  sl-switch::part(thumb) {
    width: var(--jump-switch-thumb-size) !important;
    height: var(--jump-switch-thumb-size) !important;
    background-color: var(--jump-switch-thumb-color) !important;
    border-color: var(--jump-switch-thumb-color) !important;
  }

  sl-switch[checked]::part(control) {
    background-color: var(--jump-switch-active-color) !important;
    border-color: var(--jump-switch-active-color) !important;
  }

  sl-switch::part(label) {
    margin-left: 8px;
  }

  sl-switch[disabled] {
    opacity: var(--jump-switch-disabled-opacity);
    cursor: not-allowed;
  }

  /* Stile per il contatore */
  .count {
    margin-left: auto;
    color: var(--neutral-grey-secondary, #707070);
    font-size: 0.85em;
  }
}
